// React y Hooks
import React, { useEffect, useState } from 'react'
// Third-party libraries
import { useHistory } from 'react-router-dom'
import Modal from 'antd/es/modal';
import DataTable from 'react-data-table-component';
// Material UI components
import { Button, Container,Grid, Typography, Input, Backdrop, CircularProgress } from '@material-ui/core'
// Local files
import ModalCommon from '../../common/Modal/ModalCommon'
import { customStyleSecondary } from '../../common/CommonStyles'
import { FormatNumberMXN, getModalStyle } from '../../common/Utils';
// Local files Modal
import { ColumnsOrderDetailServices } from './ColumnsOrderDetailServices'
    
const OrderDetailReceiptAdd = ({ classes,t,AddOrderDetailReceipt,allowAddReceipt,setAllowAddReceipt,setCompletReceipt, ...props }) => {
    // Routing
    const history = useHistory()
    //Get params from url
    const { match: { params } } = props;
    // UI states
    const [openBackdrop, setOpenBackdrop] = useState(false);
    // Datatable data state
    const [data, setData] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    
    //Information to send
    const [file, setFile] = useState(null);
    const [selectRows, setSelectRows] = useState([]);
    const [totalAmount,  setTotalAmount] = useState(0);

    // config of pagination for DataTable
    const paginationOptions = { 
        rowsPerPageText: t('commonMessages.rowsPerPage'), 
        rangeSeparatorText: t('common.to'), 
        selectAllRowsItem: true, 
        selectAllRowsItemText: t('common.all') 
    }
    //Modal
    const [modalStyle] = useState(getModalStyle);
    const [openModalSaveReceipt, setOpenModalSaveReceipt] = useState(false);
    //Loading events
    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    //Load services without assign 
    const fetchReceiptServicesFreeByOrder = () => {
        handleOpenBackdrop()
        props.actions.fetch_receipt_services_free_by_order(
            props.userLanguage,
            props.userToken, 
            params.pymtOrdId, 
            onError, 
            onSuccessOrderDetailReceipt
        )
    }

    const onSuccessOrderDetailReceipt = (response) => {
        handleCloseBackdrop();
        setData(response);
        setFilteredItems(response);
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    return;
                case 403:
                    history.push('/forbidden')
                    return;
                default:
                    break
            }
        }
        Modal.error({
            title: 'Error',
            content: t('commonMessages.alert500')
        })
    }

    const handleAdd = () => {
        onOpenModal();
        fetchReceiptServicesFreeByOrder();
    }

    // Open modal
    const onOpenModal = () => {
        setOpenModalSaveReceipt(true);
        CleanValues();
    }

    // Close modal
    const onCloseModal = () => {
        setOpenModalSaveReceipt(false);
        CleanValues();
    }

    //Clean values
    const CleanValues = () => {
        setFile(null);
        setSelectRows([]);
        setTotalAmount(0);
    }

    const onSubmitSaveReceipt = () => {
        handleOpenBackdrop()
        const contractIds = selectRows.map(s => (s.contractSvcOrdId));

        const formData = new FormData()
        formData.append('FormFile', file)
        formData.append('TotalAmount', totalAmount)
        formData.append('ContractSvcOrdIdArr', JSON.stringify(contractIds));

        props.actions.save_receipt(
            props.userLanguage, 
            props.userToken, 
            formData, 
            onError, 
            onSuccessSave)
    }

    const onSuccessSave = (res) => {
        handleCloseBackdrop();
        Modal.success({
            content: t('commonMessages.savedSucc'),
            onOk() {
                AddOrderDetailReceipt(res); 
                setAllowAddReceipt(selectRows.length < data.length)
                setCompletReceipt(selectRows.length === data.length)
                setTimeout(() => {
                    onCloseModal();
                  },500)
            },
        });
    }

    //On select rows in datatable
    const handleChangeSelectRows = ({ selectedRows }) => {
        setSelectRows(selectedRows)
        const total = selectedRows.reduce((acc, row) => acc + row.subtotal, 0);
        setTotalAmount(total);
    };


    //Load input file
    const handleFileChange = (e) => {
        let file = e.target.files[0]
        if (file === undefined)
        {
            setFile(null)
            return false
        }
        if(e.target.files.length ===0)
        {
            setFile(null)
            return false
        }
        if (!(file && file.size > 0))
        {
            setFile(null)
            return false
        }
        let types = ['application/pdf', 'image/png', 'image/jpeg']
        
        if (types.every(type => file.type !== type)) {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.unsupportedFormat')
            })
            setFile(null)
            e.target.value = null
            return false
        }

        const fileSize = file.size / 1024 / 1024; // in MB
        if (fileSize > 25)
        {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.MaxSizeFileAllow')
            })
            setFile(null)
            e.target.value = null
            return false
        }
    

        // load file
        setFile(file)
    }
useEffect(() => {
        console.log("allowAddReceipt",allowAddReceipt);
        
    }, [allowAddReceipt])// eslint-disable-line react-hooks/exhaustive-deps
    return (
        <>
            <Button 
                type="button" 
                className={classes.generalBorderWithOutUpperCase} 
                variant="outlined" 
                onClick={handleAdd}
                disabled={!allowAddReceipt}
            > 
                {t('OrderDetailReceipt.ButtonAddReceipt')} 
            </Button>
            <Container style={modalStyle} maxWidth="sm" className={classes.paper}>
                <ModalCommon 
                    title={t(`OrderDetailReceipt.ModalTittle`)}
                    status='default'
                    open={openModalSaveReceipt}
                    clickOpen={onCloseModal}
                    clickSubmit={onSubmitSaveReceipt}
                    submitButtonOff={false} 
                    closeButtonOff = {false} 
                    submitButtonTitle = {t(`OrderDetailReceipt.LoadFile`)}
                    closeButtonTitle = {t(`common.cancel`)}
                    maxWidth='xl'
                    disableSubmit = {file == null || totalAmount<=0}
                >
                    <Backdrop className={classes.backdrop} open={openBackdrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Grid container spacing={1}>
                        {/* <Grid item xs={12} className={classes.marginTop} /> */}
                        <Grid item xs={10}>
                            <Typography variant="body2" >
                                <b>
                                    {t(`OrderDetailReceipt.ReceiptRigth`)}
                                    <span className={classes.Requerid}>*</span>&nbsp;&nbsp;: 
                                </b>
                            </Typography>
                            <Input
                                fullWidth
                                type="file"
                                name="receipt"
                                onChange={handleFileChange}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Typography variant="body2" >
                                <b>
                                    {t(`OrderDetailReceipt.Amount`)}
                                    <span className={classes.Requerid}>*</span>&nbsp;&nbsp;:
                                </b>
                            </Typography>
                            <Typography variant="body2" >
                                {FormatNumberMXN(totalAmount)}
                            </Typography>                            
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body2" >
                                {selectRows.length > 0 &&
                                    <span>
                                        {t(`OrderDetailReceipt.ServicesSelect`)}&nbsp;{selectRows.length}
                                    </span>
                                }
                                &nbsp;
                            </Typography>
                            <DataTable
                                columns={ColumnsOrderDetailServices(t)}
                                persistTableHead
                                data={filteredItems}
                                customStyles={customStyleSecondary}
                                fixedHeader={true}
                                fixedHeaderScrollHeight={'300px'}
                                highlightOnHover
                                pointerOnHover
                                responsive
                                striped
                                pagination
                                paginationComponentOptions={paginationOptions}
                                noHeader
                                selectableRows
                                onSelectedRowsChange={handleChangeSelectRows}
                                noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                            />      
                        </Grid>
                    </Grid>
                </ModalCommon>
            </Container>
        </>
    )
}

export default OrderDetailReceiptAdd